<!-- <ng-template #template class="modal-changeLang"> -->
<div class="modal-header justify-content-between align-items-center">
    <h5 class="modal-title" id="exampleModalLabel">{{ translationKeys.Authorization.SelectLanguage | translate }}</h5>
    <a class="cursor" aria-label="Close" (click)="closemodal()"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
</div>
<div class="modal-body" data-simplebar class="change-lang">

    <form [formGroup]="mygroup">
        <div class="form-check">
            <input type="radio" formControlName="selectedlanguage" value="en" name="selectedlanguage" [checked]="mygroup.value.selectedlanguage =='en'" class="form-check-input" checked id="customRadio1">
            <label class="form-check-label" for="customRadio1">{{ translationKeys.Label.English | translate }}</label>
        </div>
        <div class="form-check">
            <input type="radio" formControlName="selectedlanguage" value="de" name="selectedlanguage" [checked]="mygroup.value.selectedlanguage =='de'" class="form-check-input" id="customRadio2">
            <label class="form-check-label" for="customRadio2">{{ translationKeys.Label.German | translate }}</label>
        </div>
        <div class="form-check">
            <input type="radio" formControlName="selectedlanguage" value="hu" name="selectedlanguage" [checked]="mygroup.value.selectedlanguage =='hu'" class="form-check-input" id="customRadio3">
            <label class="form-check-label" for="customRadio3">{{ translationKeys.Label.Hungarian | translate }}</label>
        </div>
        <div class="form-check">
            <input type="radio" formControlName="selectedlanguage" value="es" name="selectedlanguage" [checked]="mygroup.value.selectedlanguage =='es'" class="form-check-input" id="customRadio4">
            <label class="form-check-label" for="customRadio4">{{ translationKeys.Label.Spanish | translate }}</label>
        </div>
        <div class="form-check">
            <input type="radio" formControlName="selectedlanguage" value="fr" name="selectedlanguage" [checked]="mygroup.value.selectedlanguage =='fr'" class="form-check-input" id="customRadio5">
            <label class="form-check-label" for="customRadio5">{{ translationKeys.Label.French | translate }}</label>
        </div>
        <div class="form-check">
            <input type="radio" formControlName="selectedlanguage" value="cs" name="selectedlanguage" [checked]="mygroup.value.selectedlanguage =='cs'" class="form-check-input" id="customRadio6">
            <label class="form-check-label" for="customRadio6">{{ translationKeys.Label.Czeck | translate }}</label>
        </div>
        <div class="form-check">
            <input type="radio" formControlName="selectedlanguage" value="sk" name="selectedlanguage" [checked]="mygroup.value.selectedlanguage =='sk'" class="form-check-input" id="customRadio7">
            <label class="form-check-label" for="customRadio7">{{ translationKeys.Label.Slovakian | translate }}</label>
        </div>
        <div class="form-check">
            <input type="radio" formControlName="selectedlanguage" value="nl" name="selectedlanguage" [checked]="mygroup.value.selectedlanguage =='nl'" class="form-check-input" id="customRadio8">
            <label class="form-check-label" for="customRadio8">{{ translationKeys.Label.Dutch | translate }}</label>
        </div>
        <div class="form-check">
            <input type="radio" formControlName="selectedlanguage" value="ca" name="selectedlanguage" [checked]="mygroup.value.selectedlanguage =='ca'" class="form-check-input" id="customRadio9">
            <label class="form-check-label" for="customRadio9">{{ translationKeys.Label.Catalan | translate }}</label>
        </div>
        <div class="form-check">
            <input type="radio" formControlName="selectedlanguage" value="pt" name="selectedlanguage" [checked]="mygroup.value.selectedlanguage =='pt'" class="form-check-input" id="customRadio10">
            <label class="form-check-label" for="customRadio10">{{ translationKeys.Label.Portuguese | translate }}</label>
        </div>
    </form>
</div>
<div class="modal-footer">
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-6 my-3">
                <button type="button" class="btn btn-block btn-primary" (click)="selectLang()">{{ translationKeys.Authorization.Done |
                    translate }}</button>
            </div>
        </div>
    </div>
</div>
<!-- </ng-template> -->